import { Box, Image, Tag } from "@chakra-ui/react";
import HeaderCell from "components/table/HeaderCell";
import moment from "moment";

const getStatusColor = (status) => {
  switch (status) {
    case "requested":
      return "#FFD6D6";
    case "sent":
      return "#E4FAEE";
    case "Pending Approval":
      return "#FF000029";
    case "Rejected":
      return "#FBF5E2";
    case "Sold":
      return "#E7E7E7";
    default:
      return "gray.100";
  }
};

const getStatusTextColor = (status) => {
  switch (status) {
    case "requested":
      return "#FF0000";
    case "sent":
      return "#157E36";
    case "Pending Approval":
      return "#6C4800";
    case "Rejected":
      return "#6C4800";
    case "Sold":
      return "#505052";
    default:
      return "gray.100";
  }
};

const columns = (handleViewClick) => [
  {
    name: <HeaderCell label={"REQUEST ID"} />,
    selector: (row) => row?.id,
    minWidth: "200px",
  },
  {
    name: <HeaderCell label={"NO. OF BAGS"} />,
    selector: (row) => row?.number_of_bags,
  },
  {
    name: <HeaderCell label={"REQUESTED DATE"} />,
    selector: (row) => {
      if (row.date_requested)
        return moment(row.date_requested).format("DD/M/YYYY");
      return "";
    },
  },
  {
    name: <HeaderCell label={"STATUS"} />,
    selector: (row) => {
      return (
        <Tag
          bg={getStatusColor(row.status)}
          borderRadius="full"
          px="4"
          py="2"
          w={"auto"}
          justifyContent={"center"}
          alignItems={"center"}
          color={getStatusTextColor(row.status)}
          fontFamily={"PlusJakartaSansRegular"}
          fontSize={"16px"}
        >
          <Box
            bg={getStatusTextColor(row.status)}
            width={"8px"}
            height={"8px"}
            borderRadius={50}
            marginRight={"10px"}
          />
          {row?.status.charAt(0).toUpperCase() + row?.status.slice(1)}
        </Tag>
      );
    },
  },
  {
    name: <HeaderCell label={"ACTIONS"} />,
    selector: (row) => (
      <Image
        src={require("assets/svgs/eye.svg").default}
        onClick={() => handleViewClick(row)}
        _hover={{ cursor: "pointer" }}
      />
    ),
  },
];

export { columns };
